module.exports = __webpack_public_path__ + "media/images/calendar_today-purple-18dp-56838b3982260ae96f9f3529fac57de7.svg";